import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "angle-bottom",
  "use": "angle-bottom-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\" id=\"angle-bottom\">\n    <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M0 1.326L5 6l5-4.674L8.582 0 5 3.348 1.418 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol